"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFirstOccurrence = void 0;
const ramda_1 = require("ramda");
/**
 * Find the first element that is contained in both arrays given as parameters
 *
 * @param firstArray - Array of elements
 * @param secondArray - Array of elements
 * @returns The first element found in both arrays
 *
 * @public
 *
 * @example
 * ```ts
 * const array1 = [1,2,3,4,5]
 * const array2 = [4,3,5,6]
 * cont firstElementFound = findFirst<number>(array1, array2)l
 * console.log(firstElementFound);
 * // -> 4
 * ```
 */
function findFirstOccurrence(firstArray = [], secondArray = []) {
    return (0, ramda_1.find)((0, ramda_1.includes)(ramda_1.__, secondArray))(firstArray);
}
exports.findFirstOccurrence = findFirstOccurrence;
//# sourceMappingURL=find-first-occurrence.js.map